import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetUrlTitleDetailsQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String'];
	country: Types.Scalars['Country'];
	language: Types.Scalars['Language'];
	episodeMaxLimit?: Types.Maybe<Types.Scalars['Int']>;
	platform?: Types.Platform;
	allowSponsoredRecommendations?: Types.Maybe<Types.SponsoredRecommendationsInput>;
}>;

export type GetUrlTitleDetailsQuery = { __typename?: 'Query' } & {
	urlV2: { __typename?: 'Url' } & Pick<
		Types.Url,
		'id' | 'metaDescription' | 'metaKeywords' | 'metaRobots' | 'metaTitle' | 'heading1' | 'heading2' | 'htmlContent'
	> & {
			node:
				| ({ __typename?: 'Article' } & Pick<Types.Article, 'id'>)
				| ({ __typename?: 'Author' } & Pick<Types.Author, 'id'>)
				| ({ __typename?: 'Bundle' } & Pick<Types.Bundle, 'id'>)
				| ({ __typename?: 'Device' } & Pick<Types.Device, 'id'>)
				| ({ __typename?: 'Episode' } & Pick<Types.Episode, 'id'>)
				| ({ __typename?: 'GenericTitleList' } & Pick<Types.GenericTitleList, 'id'>)
				| ({ __typename?: 'Genre' } & Pick<Types.Genre, 'id'>)
				| ({ __typename?: 'Movie' } & Pick<
						Types.Movie,
						'objectType' | 'objectId' | 'offerCount' | 'permanentAudiences' | 'id'
				  > & {
							offers: Array<
								{ __typename?: 'Offer' } & Pick<Types.Offer, 'monetizationType'> & {
										package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'packageId'>;
									}
							>;
							promotedBundles: Array<
								{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'>
							>;
							availableTo: Array<
								{ __typename?: 'AvailableTo' } & Pick<
									Types.AvailableTo,
									'availableCountDown' | 'availableToDate'
								> & { package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'> }
							>;
							fallBackClips: { __typename?: 'MovieContent' } & {
								videobusterClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
								dailymotionClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
							};
							content: { __typename?: 'MovieContent' } & Pick<
								Types.MovieContent,
								| 'originalTitle'
								| 'ageCertification'
								| 'productionCountries'
								| 'fullPath'
								| 'posterUrl'
								| 'runtime'
								| 'isReleased'
								| 'shortDescription'
								| 'title'
								| 'originalReleaseYear'
								| 'originalReleaseDate'
							> & {
									credits: Array<
										{ __typename?: 'Credit' } & Pick<
											Types.Credit,
											'role' | 'name' | 'characterName' | 'personId'
										>
									>;
									backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
									clips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									videobusterClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									dailymotionClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									externalIds: { __typename?: 'ExternalIds' } & Pick<Types.ExternalIds, 'imdbId'>;
									genres: Array<{ __typename?: 'Genre' } & Pick<Types.Genre, 'shortName'>>;
									scoring: { __typename?: 'Scoring' } & Pick<
										Types.Scoring,
										'imdbScore' | 'imdbVotes' | 'tmdbPopularity' | 'tmdbScore'
									>;
									upcomingReleases: Array<
										{ __typename?: 'UpcomingRelease' } & Pick<
											Types.UpcomingRelease,
											'releaseCountDown' | 'releaseDate' | 'label'
										> & {
												package?: Types.Maybe<
													{ __typename?: 'Package' } & Pick<
														Types.Package,
														'id' | 'packageId' | 'shortName'
													>
												>;
											}
									>;
								};
							watchlistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							likelistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							dislikelistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							customlistEntries: Array<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'> & {
										genericTitleList: { __typename?: 'GenericTitleList' } & Pick<
											Types.GenericTitleList,
											'id'
										>;
									}
							>;
							similarTitlesV2: { __typename?: 'SimilarTitlesConnection' } & {
								sponsoredAd?: Types.Maybe<
									{ __typename?: 'SponsoredRecommendationAd' } & Pick<
										Types.SponsoredRecommendationAd,
										'bidId' | 'holdoutGroup'
									> & {
											campaign: { __typename?: 'SponsoredRecommendationCampaign' } & Pick<
												Types.SponsoredRecommendationCampaign,
												'hideRatings'
											>;
										}
								>;
							};
							seenlistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
						})
				| ({ __typename?: 'MultiStepSportEvent' } & Pick<Types.MultiStepSportEvent, 'id'>)
				| ({ __typename?: 'Offer' } & Pick<Types.Offer, 'id'>)
				| ({ __typename?: 'Package' } & Pick<Types.Package, 'id'>)
				| ({ __typename?: 'Page' } & Pick<Types.Page, 'id'>)
				| ({ __typename?: 'Person' } & Pick<Types.Person, 'id'>)
				| ({ __typename?: 'Season' } & Pick<
						Types.Season,
						'objectType' | 'objectId' | 'offerCount' | 'totalEpisodeCount' | 'id'
				  > & {
							offers: Array<
								{ __typename?: 'Offer' } & Pick<Types.Offer, 'monetizationType'> & {
										package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'packageId'>;
									}
							>;
							promotedBundles: Array<
								{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'>
							>;
							availableTo: Array<
								{ __typename?: 'AvailableTo' } & Pick<
									Types.AvailableTo,
									'availableCountDown' | 'availableToDate'
								> & { package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'> }
							>;
							fallBackClips: { __typename?: 'SeasonContent' } & {
								videobusterClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
								dailymotionClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
							};
							content: { __typename?: 'SeasonContent' } & Pick<
								Types.SeasonContent,
								| 'seasonNumber'
								| 'fullPath'
								| 'posterUrl'
								| 'runtime'
								| 'isReleased'
								| 'shortDescription'
								| 'title'
								| 'originalReleaseYear'
								| 'originalReleaseDate'
							> & {
									backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
									clips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									videobusterClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									dailymotionClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									externalIds: { __typename?: 'ExternalIds' } & Pick<Types.ExternalIds, 'imdbId'>;
									genres: Array<{ __typename?: 'Genre' } & Pick<Types.Genre, 'shortName'>>;
									scoring: { __typename?: 'Scoring' } & Pick<
										Types.Scoring,
										'imdbScore' | 'imdbVotes' | 'tmdbPopularity' | 'tmdbScore'
									>;
									upcomingReleases: Array<
										{ __typename?: 'UpcomingRelease' } & Pick<
											Types.UpcomingRelease,
											'releaseCountDown' | 'releaseDate' | 'label'
										> & {
												package?: Types.Maybe<
													{ __typename?: 'Package' } & Pick<
														Types.Package,
														'id' | 'packageId' | 'shortName'
													>
												>;
											}
									>;
								};
							episodes: Array<
								{ __typename?: 'Episode' } & Pick<Types.Episode, 'id' | 'objectType' | 'objectId'> & {
										seenlistEntry?: Types.Maybe<
											{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
										>;
										content: { __typename?: 'EpisodeContent' } & Pick<
											Types.EpisodeContent,
											| 'title'
											| 'shortDescription'
											| 'episodeNumber'
											| 'seasonNumber'
											| 'isReleased'
										> & {
												upcomingReleases: Array<
													{ __typename?: 'UpcomingRelease' } & Pick<
														Types.UpcomingRelease,
														'releaseDate' | 'label'
													> & {
															package?: Types.Maybe<
																{ __typename?: 'Package' } & Pick<
																	Types.Package,
																	'id' | 'packageId'
																>
															>;
														}
												>;
											};
									}
							>;
							show: { __typename?: 'Show' } & Pick<
								Types.Show,
								'id' | 'objectId' | 'objectType' | 'totalSeasonCount'
							> & {
									customlistEntries: Array<
										{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'> & {
												genericTitleList: { __typename?: 'GenericTitleList' } & Pick<
													Types.GenericTitleList,
													'id'
												>;
											}
									>;
									fallBackClips: { __typename?: 'ShowContent' } & {
										videobusterClips: Array<
											{ __typename?: 'Clip' } & Pick<Types.Clip, 'externalId' | 'provider'>
										>;
										dailymotionClips: Array<
											{ __typename?: 'Clip' } & Pick<Types.Clip, 'externalId' | 'provider'>
										>;
									};
									content: { __typename?: 'ShowContent' } & Pick<
										Types.ShowContent,
										| 'title'
										| 'ageCertification'
										| 'fullPath'
										| 'productionCountries'
										| 'posterUrl'
										| 'isReleased'
									> & {
											genres: Array<{ __typename?: 'Genre' } & Pick<Types.Genre, 'shortName'>>;
											credits: Array<
												{ __typename?: 'Credit' } & Pick<
													Types.Credit,
													'role' | 'name' | 'characterName' | 'personId'
												>
											>;
											externalIds: { __typename?: 'ExternalIds' } & Pick<
												Types.ExternalIds,
												'imdbId'
											>;
											upcomingReleases: Array<
												{ __typename?: 'UpcomingRelease' } & Pick<
													Types.UpcomingRelease,
													'releaseDate'
												>
											>;
											backdrops: Array<
												{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>
											>;
											videobusterClips: Array<
												{ __typename?: 'Clip' } & Pick<Types.Clip, 'externalId' | 'provider'>
											>;
											dailymotionClips: Array<
												{ __typename?: 'Clip' } & Pick<Types.Clip, 'externalId' | 'provider'>
											>;
										};
									seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'progress'>;
									watchlistEntry?: Types.Maybe<
										{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
									>;
									dislikelistEntry?: Types.Maybe<
										{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
									>;
									likelistEntry?: Types.Maybe<
										{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
									>;
									similarTitlesV2: { __typename?: 'SimilarTitlesConnection' } & {
										sponsoredAd?: Types.Maybe<
											{ __typename?: 'SponsoredRecommendationAd' } & Pick<
												Types.SponsoredRecommendationAd,
												'bidId' | 'holdoutGroup'
											> & {
													campaign: { __typename?: 'SponsoredRecommendationCampaign' } & Pick<
														Types.SponsoredRecommendationCampaign,
														'hideRatings'
													>;
												}
										>;
									};
								};
							seenState: { __typename?: 'ShowSeenState' } & Pick<Types.ShowSeenState, 'progress'>;
						})
				| ({ __typename?: 'Show' } & Pick<
						Types.Show,
						'objectType' | 'objectId' | 'offerCount' | 'permanentAudiences' | 'totalSeasonCount' | 'id'
				  > & {
							offers: Array<
								{ __typename?: 'Offer' } & Pick<Types.Offer, 'monetizationType'> & {
										package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'packageId'>;
									}
							>;
							promotedBundles: Array<
								{ __typename?: 'PromotedBundleEdge' } & Pick<Types.PromotedBundleEdge, 'promotionUrl'>
							>;
							availableTo: Array<
								{ __typename?: 'AvailableTo' } & Pick<
									Types.AvailableTo,
									'availableCountDown' | 'availableToDate'
								> & { package: { __typename?: 'Package' } & Pick<Types.Package, 'id' | 'shortName'> }
							>;
							fallBackClips: { __typename?: 'ShowContent' } & {
								videobusterClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
								dailymotionClips: Array<
									{ __typename?: 'Clip' } & Pick<Types.Clip, 'sourceUrl' | 'externalId' | 'provider'>
								>;
							};
							content: { __typename?: 'ShowContent' } & Pick<
								Types.ShowContent,
								| 'originalTitle'
								| 'ageCertification'
								| 'productionCountries'
								| 'fullPath'
								| 'posterUrl'
								| 'runtime'
								| 'isReleased'
								| 'shortDescription'
								| 'title'
								| 'originalReleaseYear'
								| 'originalReleaseDate'
							> & {
									credits: Array<
										{ __typename?: 'Credit' } & Pick<
											Types.Credit,
											'role' | 'name' | 'characterName' | 'personId'
										>
									>;
									backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
									clips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									videobusterClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									dailymotionClips: Array<
										{ __typename?: 'Clip' } & Pick<
											Types.Clip,
											'sourceUrl' | 'externalId' | 'provider'
										>
									>;
									externalIds: { __typename?: 'ExternalIds' } & Pick<Types.ExternalIds, 'imdbId'>;
									genres: Array<{ __typename?: 'Genre' } & Pick<Types.Genre, 'shortName'>>;
									scoring: { __typename?: 'Scoring' } & Pick<
										Types.Scoring,
										'imdbScore' | 'imdbVotes' | 'tmdbPopularity' | 'tmdbScore'
									>;
									upcomingReleases: Array<
										{ __typename?: 'UpcomingRelease' } & Pick<
											Types.UpcomingRelease,
											'releaseCountDown' | 'releaseDate' | 'label'
										> & {
												package?: Types.Maybe<
													{ __typename?: 'Package' } & Pick<
														Types.Package,
														'id' | 'packageId' | 'shortName'
													>
												>;
											}
									>;
								};
							watchlistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							likelistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							dislikelistEntry?: Types.Maybe<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
							>;
							customlistEntries: Array<
								{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'> & {
										genericTitleList: { __typename?: 'GenericTitleList' } & Pick<
											Types.GenericTitleList,
											'id'
										>;
									}
							>;
							similarTitlesV2: { __typename?: 'SimilarTitlesConnection' } & {
								sponsoredAd?: Types.Maybe<
									{ __typename?: 'SponsoredRecommendationAd' } & Pick<
										Types.SponsoredRecommendationAd,
										'bidId' | 'holdoutGroup'
									> & {
											campaign: { __typename?: 'SponsoredRecommendationCampaign' } & Pick<
												Types.SponsoredRecommendationCampaign,
												'hideRatings'
											>;
										}
								>;
							};
							seenState: { __typename?: 'ShowSeenState' } & Pick<
								Types.ShowSeenState,
								'progress' | 'seenEpisodeCount'
							>;
							seasons: Array<
								{ __typename?: 'Season' } & Pick<Types.Season, 'id' | 'objectId' | 'objectType'> & {
										availableTo: Array<
											{ __typename?: 'AvailableTo' } & Pick<
												Types.AvailableTo,
												'availableToDate' | 'availableCountDown'
											> & {
													package: { __typename?: 'Package' } & Pick<
														Types.Package,
														'id' | 'shortName'
													>;
												}
										>;
										content: { __typename?: 'SeasonContent' } & Pick<
											Types.SeasonContent,
											'posterUrl' | 'seasonNumber' | 'fullPath' | 'isReleased'
										> & {
												upcomingReleases: Array<
													{ __typename?: 'UpcomingRelease' } & Pick<
														Types.UpcomingRelease,
														'releaseDate' | 'releaseCountDown'
													> & {
															package?: Types.Maybe<
																{ __typename?: 'Package' } & Pick<
																	Types.Package,
																	'id' | 'shortName'
																>
															>;
														}
												>;
											};
										show: { __typename?: 'Show' } & Pick<
											Types.Show,
											'id' | 'objectId' | 'objectType'
										> & {
												watchlistEntry?: Types.Maybe<
													{ __typename?: 'TitleListEntry' } & Pick<
														Types.TitleListEntry,
														'createdAt'
													>
												>;
												content: { __typename?: 'ShowContent' } & Pick<
													Types.ShowContent,
													'title'
												>;
											};
									}
							>;
							recentEpisodes: Array<
								{ __typename?: 'Episode' } & Pick<Types.Episode, 'id' | 'objectId'> & {
										content: { __typename?: 'EpisodeContent' } & Pick<
											Types.EpisodeContent,
											| 'title'
											| 'shortDescription'
											| 'episodeNumber'
											| 'seasonNumber'
											| 'isReleased'
										> & {
												upcomingReleases: Array<
													{ __typename?: 'UpcomingRelease' } & Pick<
														Types.UpcomingRelease,
														'releaseDate' | 'label'
													>
												>;
											};
										seenlistEntry?: Types.Maybe<
											{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
										>;
									}
							>;
						})
				| ({ __typename?: 'SingleStepSportEvent' } & Pick<Types.SingleStepSportEvent, 'id'>)
				| ({ __typename?: 'SportCompetitionV2' } & Pick<Types.SportCompetitionV2, 'id'>)
				| ({ __typename?: 'SportCompetitorV2' } & Pick<Types.SportCompetitorV2, 'id'>)
				| ({ __typename?: 'Url' } & Pick<Types.Url, 'id'>);
		};
};

export const GetUrlTitleDetailsDocument = gql`
	query GetUrlTitleDetails(
		$fullPath: String!
		$country: Country!
		$language: Language!
		$episodeMaxLimit: Int
		$platform: Platform! = WEB
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
	) {
		urlV2(fullPath: $fullPath) {
			id
			metaDescription
			metaKeywords
			metaRobots
			metaTitle
			heading1
			heading2
			htmlContent
			node {
				id
				... on MovieOrShowOrSeason {
					objectType
					objectId
					offerCount(country: $country, platform: $platform)
					offers(country: $country, platform: $platform) {
						monetizationType
						package {
							id
							packageId
						}
					}
					promotedBundles(country: $country, platform: $platform) {
						promotionUrl
					}
					availableTo(country: $country, platform: $platform) {
						availableCountDown(country: $country)
						availableToDate
						package {
							id
							shortName
						}
					}
					fallBackClips: content(country: "US", language: "en") {
						videobusterClips: clips(providers: [VIDEOBUSTER]) {
							sourceUrl
							externalId
							provider
						}
						dailymotionClips: clips(providers: [DAILYMOTION]) {
							sourceUrl
							externalId
							provider
						}
					}
					content(country: $country, language: $language) {
						backdrops {
							backdropUrl
						}
						clips {
							sourceUrl
							externalId
							provider
						}
						videobusterClips: clips(providers: [VIDEOBUSTER]) {
							sourceUrl
							externalId
							provider
						}
						dailymotionClips: clips(providers: [DAILYMOTION]) {
							sourceUrl
							externalId
							provider
						}
						externalIds {
							imdbId
						}
						fullPath
						genres {
							shortName
						}
						posterUrl
						runtime
						isReleased
						scoring {
							imdbScore
							imdbVotes
							tmdbPopularity
							tmdbScore
						}
						shortDescription
						title
						originalReleaseYear
						originalReleaseDate
						upcomingReleases(releaseTypes: DIGITAL) {
							releaseCountDown(country: $country)
							releaseDate
							label
							package {
								id
								packageId
								shortName
							}
						}
						... on MovieOrShowContent {
							originalTitle
							ageCertification
							credits {
								role
								name
								characterName
								personId
							}
							productionCountries
						}
						... on SeasonContent {
							seasonNumber
						}
					}
				}
				... on MovieOrShow {
					watchlistEntry {
						createdAt
					}
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					customlistEntries {
						createdAt
						genericTitleList {
							id
						}
					}
					similarTitlesV2(country: $country, allowSponsoredRecommendations: $allowSponsoredRecommendations) {
						sponsoredAd {
							bidId
							holdoutGroup
							campaign {
								hideRatings
							}
						}
					}
				}
				... on Movie {
					permanentAudiences
					seenlistEntry {
						createdAt
					}
				}
				... on Show {
					permanentAudiences
					totalSeasonCount
					seenState(country: $country) {
						progress
						seenEpisodeCount
					}
					seasons(sortDirection: DESC) {
						id
						objectId
						objectType
						availableTo(country: $country, platform: $platform) {
							availableToDate
							availableCountDown(country: $country)
							package {
								id
								shortName
							}
						}
						content(country: $country, language: $language) {
							posterUrl
							seasonNumber
							fullPath
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
								releaseCountDown(country: $country)
								package {
									id
									shortName
								}
							}
							isReleased
						}
						show {
							id
							objectId
							objectType
							watchlistEntry {
								createdAt
							}
							content(country: $country, language: $language) {
								title
							}
						}
					}
					recentEpisodes: episodes(sortDirection: DESC, limit: 3, releasedInCountry: $country) {
						id
						objectId
						content(country: $country, language: $language) {
							title
							shortDescription
							episodeNumber
							seasonNumber
							isReleased
							upcomingReleases {
								releaseDate
								label
							}
						}
						seenlistEntry {
							createdAt
						}
					}
				}
				... on Season {
					totalEpisodeCount
					episodes(limit: $episodeMaxLimit) {
						id
						objectType
						objectId
						seenlistEntry {
							createdAt
						}
						content(country: $country, language: $language) {
							title
							shortDescription
							episodeNumber
							seasonNumber
							isReleased
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
								label
								package {
									id
									packageId
								}
							}
						}
					}
					show {
						id
						objectId
						objectType
						totalSeasonCount
						customlistEntries {
							createdAt
							genericTitleList {
								id
							}
						}
						fallBackClips: content(country: "US", language: "en") {
							videobusterClips: clips(providers: [VIDEOBUSTER]) {
								externalId
								provider
							}
							dailymotionClips: clips(providers: [DAILYMOTION]) {
								externalId
								provider
							}
						}
						content(country: $country, language: $language) {
							title
							ageCertification
							fullPath
							genres {
								shortName
							}
							credits {
								role
								name
								characterName
								personId
							}
							productionCountries
							externalIds {
								imdbId
							}
							upcomingReleases(releaseTypes: DIGITAL) {
								releaseDate
							}
							backdrops {
								backdropUrl
							}
							posterUrl
							isReleased
							videobusterClips: clips(providers: [VIDEOBUSTER]) {
								externalId
								provider
							}
							dailymotionClips: clips(providers: [DAILYMOTION]) {
								externalId
								provider
							}
						}
						seenState(country: $country) {
							progress
						}
						watchlistEntry {
							createdAt
						}
						dislikelistEntry {
							createdAt
						}
						likelistEntry {
							createdAt
						}
						similarTitlesV2(
							country: $country
							allowSponsoredRecommendations: $allowSponsoredRecommendations
						) {
							sponsoredAd {
								bidId
								holdoutGroup
								campaign {
									hideRatings
								}
							}
						}
					}
					seenState(country: $country) {
						progress
					}
				}
			}
		}
	}
`;
